import axios from 'axios';
import * as travelAreaService from '../services/travelAreaSelection';
import _ from 'lodash';

export function fetchTags(filter) {
    let optionalParams = '';
    if (filter.isOr) {
        optionalParams += '?tx_nezzotaggingsystem_tagapi[logicalOperator]=' + 0;
    }
    if (filter.tagGroups) {
        return axios.get(getBaseUrl() + 'tagging/tags/' + filter.tagGroups.join(',') + optionalParams);
    } else {
        return axios.get(getBaseUrl() + 'tagging/tags/' + optionalParams);
    }
}

export function fetchTeasers(filter, pagination) {
    let optionalParams = '';
    if (pagination !== null && (pagination.limit !== 0 || pagination.offset !== 0)) {
        optionalParams = '?tx_nezzotaggingsystem_tagapi[limit]=' + pagination.limit + '&tx_nezzotaggingsystem_tagapi[offset]=' + pagination.offset;
    }
    if (filter.logicalOperator === 0) {
        optionalParams = optionalParams + '&tx_nezzotaggingsystem_tagapi[logicalOperator]=' + filter.logicalOperator;
    }
    if (getCurrentPid() !== 0) {
        optionalParams = optionalParams + '&tx_nezzotaggingsystem_tagapi[excludePid]=' + getCurrentPid();
    }
    if (filter.contentTypes !== undefined && filter.contentTypes !== null) {
        optionalParams += '&tx_nezzotaggingsystem_tagapi[contentTypes]=' + filter.contentTypes;
    }
    return axios.get(getBaseUrl() + 'tagging/teasers/' + filter.tags.map(tag => tag.uid).join(',') + optionalParams);
}

export function fetchTeaserCount(filter) {
    let optionalParams = '';
    if (filter.contentTypes !== undefined && filter.contentTypes !== null) {
        optionalParams += '?tx_nezzotaggingsystem_tagapi[contentTypes]=' + filter.contentTypes;
    }
    return axios.get(getBaseUrl() + 'tagging/teaserCount/' + filter.tags.map(tag => tag.uid).join(',') + optionalParams);
}

export function fetchPerson(uid) {
    return axios.get(getBaseUrl() + 'api/person/' + uid);
}

export function getBaseUrl() {
    let baseUrl = window.location.origin + '/';
    if (baseUrl.includes('localhost')) {
        baseUrl = 'https://kontiki.ddev.site/';
    }
    return baseUrl + getLanguageKey();
}


function getLanguageKey() {
    const languageKey = window.nezzokontikifrontend_language;
    return languageKey === 'de' ? '' : languageKey + '/';
}

function getCurrentPid() {
    return window.nezzokontikifrontend_pid;
}

export function getItinerariesByIds(uids) {
    return axios.get(getBaseUrl() + 'api/itinerary/byId?ids=' + uids.join(','));
}

export function getExcursionsByIds(uids) {
    return axios.get(getBaseUrl() + 'api/excursion/byId?ids=' + uids.join(','));
}
export function getItinerariesByLtrKeys(filterObject) {
    const newFilterObject = {...filterObject};
    const filledKeys = Object.keys(newFilterObject).filter(key => {
        return parseInt(newFilterObject[key], 10) !== 0;
    });
    const queryString = filledKeys.map(key => key + '=' + newFilterObject[key]).join('&');

    return axios.get(getBaseUrl() + 'api/itinerary/byKeys?' + queryString);
}

export function getItinerariesByFilter(filterObject) {
    const newFilterObject = {...filterObject};
    const filledKeys = Object.keys(newFilterObject).filter(key => {
        return parseInt(newFilterObject[key], 10) !== 0;
    });

    filledKeys.push('travelArea');
    _.pull(filledKeys, 'travelAreaCountry');
    _.pull(filledKeys, 'travelAreaRegion');
    _.pull(filledKeys, 'travelAreaDestination');
    newFilterObject.travelArea = travelAreaService.evaluateMostSpecificSelection(
        newFilterObject.travelAreaCountry,
        newFilterObject.travelAreaRegion,
        newFilterObject.travelAreaDestination
    );

    const queryString = filledKeys.map(key => key + '=' + newFilterObject[key]).join('&');

    return axios.get(getBaseUrl() + 'api/itinerary?' + queryString);
}

export function getExcursionsByFilter(filterObject, mapTravelAreas) {

    const newFilterObject = {...filterObject};

    const filledKeys = Object.keys(newFilterObject).filter(key => {
        return parseInt(newFilterObject[key], 10) !== 0;
    });

    if (mapTravelAreas) {
        filledKeys.push('travelArea');
        newFilterObject.travelArea = mapTravelAreas.join(',')
    } else {
        filledKeys.push('travelArea');
        newFilterObject.travelArea = travelAreaService.evaluateMostSpecificSelection(
            newFilterObject.travelAreaCountry,
            newFilterObject.travelAreaRegion,
            newFilterObject.travelAreaDestination
        );
    }

    _.pull(filledKeys, 'travelAreaCountry');
    _.pull(filledKeys, 'travelAreaRegion');
    _.pull(filledKeys, 'travelAreaDestination');

    const queryString = filledKeys.map(key => key + '=' + newFilterObject[key]).join('&');

    return axios.get(getBaseUrl() + 'api/excursion?' + queryString);
}

export function getMapExcursionsByFilter(apiUrl, filterObject) {
    const newFilterObject = {...filterObject};
    const filledKeys = Object.keys(newFilterObject).filter(key => {
        return parseInt(newFilterObject[key], 10) !== 0;
    });

    filledKeys.push('travelArea');
    _.pull(filledKeys, 'travelAreaCountry');
    _.pull(filledKeys, 'travelAreaRegion');
    _.pull(filledKeys, 'travelAreaDestination');
    newFilterObject.travelArea = travelAreaService.evaluateMostSpecificSelection(
        newFilterObject.travelAreaCountry,
        newFilterObject.travelAreaRegion,
        newFilterObject.travelAreaDestination
    );

    const queryString = filledKeys.map(key => key + '=' + newFilterObject[key]).join('&');

    return axios.get(apiUrl + '?' + queryString);
}

export function sendFavouritesEmail(itineraryIds, excursionIds, email, recaptchaToken) {
    return axios.post(getBaseUrl() + 'api/favourites', {
        itineraryIds,
        excursionIds,
        email,
        recaptchaToken
    });
}

// itineraries
export function getTravelAreasByDepth(depth) {
    return axios.get(getBaseUrl() + 'api/itinerary/options/travelAreas/' + depth);
}

export function getTagsByClvType(clvType) {
    return axios.get(getBaseUrl() + 'api/itinerary/options/tags/' + clvType);
}

export function getOptionsByClvType(clvType) {
    return axios.get(getBaseUrl() + 'api/itinerary/options/' + clvType);
}

// excursions
export function getExcursionTravelAreasByDepth(depth) {
    return axios.get(getBaseUrl() + 'api/excursion/options/travelAreas/' + depth);
}

export function getExcursionTagsByClvType(clvType) {
    return axios.get(getBaseUrl() + 'api/excursion/options/tags/' + clvType);
}

export function getExcursionOptionsByClvType(clvType) {
    return axios.get(getBaseUrl() + 'api/excursion/options/' + clvType);
}



// WEBPACK FOOTER //
// ./src/services/api.js